import * as React from 'react'
import { Widget, fromJSX } from 'widgets-for-react'

const loaderElement = (type: 'full' | 'inline') => (
  <div className={`loader loader--${type}`}>
    <div className='loader__inner'>
      <svg className='loader__image' height="46" viewBox="0 0 41 46" width="41" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <radialGradient id="a" cx="20.415226%" cy="12.402517%" gradientTransform="matrix(.56808753 .72475018 -.82296814 .50028856 .190244 -.085982)" r="100.178853%"><stop offset="0" stopColor="#253A79"/><stop offset="1" stopColor="#E9F4FD"/></radialGradient>
        <path d="m23 0c1.0162039 0 2.0170152.06590368 2.998393.19367017l.0101205.00058716c-.5477729.59003985-1.064258 1.20952576-1.5468166 1.85582041-.4829256-.03320251-.9703405-.05007774-1.4616969-.05007774-11.5979797 0-21 9.4020203-21 21s9.4020203 21 21 21c5.937669 0 11.2997767-2.4642709 15.118447-6.4263707.7833657.1546178 1.5813391.268575 2.3916299.3395816-4.2176205 4.9482725-10.4973288 8.0867891-17.5100769 8.0867891-12.7025492 0-23-10.2974508-23-23s10.2974508-23 23-23z" fill="url(#a)" fillRule="evenodd"/>
      </svg>
    </div>
  </div>
)

export const loader: Widget<never> = fromJSX(() => loaderElement('inline'))
export const loaderFull: Widget<never> = fromJSX(() => loaderElement('full'))
